<div class="col-xl-12" *ngIf="data">
	<div mat-dialog-content *ngIf="data.confirmData">
			<div fxFlex class="mb-20 profile-page-header" fxLayout="column"  fxLayoutGap="20px" *ngIf="fieldsDetails">
				<div fxFlex="100" class="topData topDataName">
					<div class="dataHead">{{data.confirmData['name']}}</div>
					<div class="dataHead">{{fieldsDetails['code']['displayName'] | translate}}: <span
							class="inlineText">{{data.confirmData['code']}}</span></div>
					<div class="dataHead">{{fieldsDetails['description']['displayName'] | translate}}: <span
							class="inlineText">{{data.confirmData['description']}}</span></div>
				</div>
			</div>
	</div>
	<div mat-dialog-actions>
		<div fxFlex class="btnList" fxLayout="row" 
			*ngIf="data.modalSetting && !data.modalSetting.hasOwnProperty('footer')" fxFlex>
				<button color="danger" mat-raised-button
					(click)="closeModal(undefined)">{{'Close' | translate}}</button>
				<button *ngIf="showEdit" mat-raised-button (click)="closeModal('edit')">
					{{'Edit' | translate}}
				</button>
		</div>
	</div>
</div>